import { TbArrowLeft, TbCheck } from "react-icons/tb";
import { Icon } from "../Icon";
import "./styles/index.scss";

// The arrow and the check were lottie animations: static Tabler icons now (no canvas, no lottie in the bundle).
// The arrow points left, as the lottie one did: `.button_hole.right` turns it by 180deg in the stylesheet.

const Button = ({
  label,
  isRed,
  isFull,
  customClassName,
  onClick,
  onMouseOver,
  onMouseLeave,
  arrowDirection = "right",
  disabled = false,
  customIcon = null,
  isPlainIcon = false, // a nav link drawing its customIcon alone, without the round hole
  isNavLink,
  isActive,
  disableIcon,
}) => {
  const arrow = TbArrowLeft;

  const handleClick = (event) => {
    if (disabled) return;
    if (onClick) {
      event.preventDefault();
      onClick(event);
    }
  };

  const handleMouseOver = (event) => {
    if (disabled) return;
    if (onMouseOver) {
      event.preventDefault();
      onMouseOver();
    }
  };

  const handleMouseLeave = (event) => {
    if (disabled) return;
    if (onMouseLeave) {
      event.preventDefault();
      onMouseLeave();
    }
  };

  const renderNavLinkIcon = () => {
    if (disableIcon) return;
    if (isPlainIcon)
      return (
        <div className="button_hole_icon_img">
          {typeof customIcon === "function" ? (
            <Icon icon={customIcon} className="icon" size="lg" aria-hidden="true" />
          ) : (
            <img className="icon" src={customIcon} alt="" />
          )}
        </div>
      );

    return (
      <div className={`button_hole ${arrowDirection}`}>
        <div className="button_hole_icon_wrapper">
          {isActive && arrowDirection === "right" && <Icon icon={TbCheck} size="lg" aria-hidden="true" />}
          <div className="button_hole_icon_main">
            <Icon icon={customIcon || arrow} size="lg" aria-hidden="true" />
          </div>
          {isActive && arrowDirection === "left" && <Icon icon={TbCheck} size="lg" aria-hidden="true" />}
        </div>
      </div>
    );
  };

  const renderArrowIcon = () => (
    <div className={`button_hole ${arrowDirection}`}>
      <div className="button_hole_icon_main">
        <Icon icon={customIcon || arrow} size="lg" aria-hidden="true" />
      </div>
    </div>
  );

  return (
    <button
      className={`button${isRed ? "_red" : ""}${isFull ? "_full" : ""} ${
        customClassName || ""
      } ${isActive && customIcon ? " active" : ""}`}
      onClick={handleClick}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      disabled={disabled}
    >
      {" "}
      {isFull && label && (
        <label className={`button_label ${customClassName || ""}`}>
          {label}
        </label>
      )}
      {isNavLink ? renderNavLinkIcon() : renderArrowIcon()}
    </button>
  );
};

export default Button;
